<template>
  <v-app class="test">
    <v-content class="bg">
      <v-container>
        <v-card
          class="mx-auto pa-2 mb-4 text-center"
          flat
          max-width="500"
        >
          <v-form
            class="my-6"
            ref="form"
            @submit.prevent="submit"
          >
            <v-text-field
              label="Enter an URL"
              v-model="url"
              required
              outlined
              :rules="[rules.required, rules.url]"
            />

            <div class="d-flex justify-center align-items-center">
              <v-btn
                color="primary"
                type="submit"
                class="mr-2"
              >
                Get urls
              </v-btn>
              <CopyButton
                v-if="result.length"
                :content="copyableContent"
              />
            </div>
          </v-form>
        </v-card>

        <ErrorAlert
          :error="error"
        />

        <v-simple-table v-if="result.length">
          <template #default>
            <thead>
              <tr>
                <th class="text-left">
                  Anchor Text
                </th>
                <th class="text-left">
                  Url
                </th>
                <th class="text-left">
                  External/Internal
                </th>
                <th class="text-left">
                  Rel
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in result"
                :key="item.url"
              >
                <td>{{ item.text }}</td>
                <td><a :href="item.url">{{ item.url }}</a></td>
                <td>{{ item.isExternalLink ? 'External Link' : 'Internal Link' }}</td>
                <td>{{ item.rel }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>

      <LoadingOverlay v-if="loading" />
    </v-content>
  </v-app>
</template>

<script>
import validationRules from '../validation-rules.js'
import { extractUrls } from '../services/api'
import ErrorAlert from '@/components/ErrorAlert.vue'
import CopyButton from '@/components/CopyButton.vue';

import LoadingOverlay from '@/components/LoadingOverlay.vue'

export default {
  name: 'ExtractUrls',
  components: { ErrorAlert, LoadingOverlay, CopyButton },
  data: () => ({
    loading: false,
    url: null,
    result: [],
    error: null,
    rules: validationRules,
  }),

  computed: {
    copyableContent() {
      if (!this.result) {
        return ''
      }

      const rows = []
      for (let i = 0; i < this.result.length; i++) {
        const item = this.result[i];
        rows.push([
          item.text,
          item.url,
          item.isExternalLink ? 'External Link' : 'Internal Link',
          item.rel
        ].join("\t"))
      }

      return rows.join("\n")
    }
  },
  methods: {
    async submit() {
      this.error = null
      this.result = []

      if (this.$refs.form.validate()) {
        // this.loading = true

        try {
          const { data } = await extractUrls({ url: this.url })
          this.result = data
        } catch (error) {
          this.error = error
        } finally {
          this.loading = false
        }
      }
    }
  },
}
</script>

<style>
td:nth-child(1) {
  word-break: break-all;
}

td:nth-child(2) {
  word-break: break-all;
}

.v-application--wrap {
  min-height: auto;
}
</style>


